import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-client-search-diff',
  templateUrl: './client-search-diff.component.html',
  styleUrls: ['./client-search-diff.component.scss']
})
export class ClientSearchDiffComponent implements OnInit {
  public loading = false;

  constructor() {}

  ngOnInit() {}
}
